import React, { forwardRef } from 'react';
import './style.scss';
// components
// eslint-disable-next-line no-unused-vars
import { TimePicker, TimePickerProps } from '@progress/kendo-react-dateinputs';
import ReadOnlyTime from './ReadOnlyTime';
import BaseTimeInput from './BaseTimeInput';

/**
 * @typedef {React.PropsWithoutRef<TimePickerProps>} TelerikTimePickerProps
 *
 * @typedef {Object} AdditionalTimePickerProps
 * @property {boolean} [readOnly={false}] Indicates if the picker is read-only. False by default.
 *
 * @param {TelerikTimePickerProps & AdditionalTimePickerProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseTimePicker = ({ readOnly = false, ...props }, ref) => {
  const { value, defaultValue } = props;

  if (readOnly) {
    return <ReadOnlyTime value={value ?? defaultValue} />;
  }

  return <TimePicker ref={ref} dateInput={BaseTimeInput} format="HH:mm" {...props} />;
};

/**
 * A base time picker component.
 *
 * @param {CustomTimeInputProps & AdditionalTimePickerProps} props Component props. Extends Telerik TimePicker props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base time picker component.
 */
const ForwardTimePicker = forwardRef(BaseTimePicker);

export default ForwardTimePicker;
